<template>
  <div>
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#007BFF"
             :is-full-page="true">
    </loading>
    <base-header class="pb-6">
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Listado de Pedidos</h3>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid ">
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">
                <div class="d-inline-block">
                  <base-button type="success" @click="downloadExcel">Excel</base-button>
                </div>
                <div class="d-inline-block pl-2">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker slot-scope="{focus, blur}"
                                 @on-open="focus"
                                 @on-close="blur"
                                 :config="dates.config"
                                 placeholder="Seleccione fecha"
                                 class="form-control datepicker"
                                 @input="dateRangeChange"
                                 v-model="dates.range">
                    </flat-picker>
                  </base-input>
                </div>
                <div class="d-inline-block pl-2">
                  Total: {{ pagination.totalItems }}
                </div>
              </div>
              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Buscar...">
                </base-input>
              </div>


            </div>
            <vue-content-loading v-if="queriedData.length === 0" :width="300" :height="170" primary="#bdc3c7" secondary="#95a5a6">
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />


              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle  cx="206" cy="155" r="5" />
              <circle  cx="219" cy="155" r="5" />
              <circle  cx="232" cy="155" r="5" />
              <circle  cx="245" cy="155" r="5" />

            </vue-content-loading>

            <el-table :data="queriedData"
                      row-key="id"
                      header-row-class-name="thead-light"
                      v-if="queriedData.length !== 0"
                      @sort-change="sortChange">

              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
            </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">
                <p class="card-category">
                  Mostrando {{ from }} a {{ to }} de {{ total }} registros
                </p>

              </div>
              <base-pagination
                class="pagination-no-border"
                @input="next"
                v-model="pagination.page"
                :per-page="pagination.rowsPerPage"
                v-if="pagination.totalItems > 10"
                :total="total"
              >
              </base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Table, TableColumn, Select, Option } from 'element-ui';
  import {mapActions,mapState,mapMutations} from 'vuex'
  import orderPaginationMixin from "../../mixin/orderPaginationMixin";
  import { VueContentLoading } from 'vue-content-loading'
  import moment from 'moment'
  import axios from 'axios'
  import flatPicker from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css';
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name: "ListPedidos",
    mixins:[orderPaginationMixin],
    components:{
      // BasePagination,
      VueContentLoading,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      flatPicker,
      Loading
    },
    data(){
      return {
        isLoading: false,
        selectedRows:[],
        propsToSearch: ['client','status','platos'],
        tableColumns: [
          {
            prop: 'client',
            label: 'Nombre',
            minWidth: 200,
            sortable: true
          },
          {
            prop: 'date',
            label: 'Fecha',
            minWidth: 150,
            sortable: true
          },
          {
            prop: 'platos',
            label: 'platos',
            minWidth: 220,
            sortable: true
          }
        ],
        tableData: [],
        pageActual:1,
        dates: {
          range: "",
          config:{allowInput: false, mode: 'range',locale: Spanish}
        },
        rangeDate:[]
      }
    },
    computed:{
      ...mapState('orders',['orders','pagination'])
    },
    methods:{
      ...mapActions('orders',['GET_ORDERS']),
      ...mapMutations('orders',['SET_ORDERS','SET_PAGINATION']),
      async downloadExcel() {
        this.isLoading = true;
        await axios({
          url: '/orders/excel',
          method: 'get',
          responseType: 'blob', // important
          params: { dates: this.rangeDate}
        }).then((response) => {
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'pedidos-' + moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
          .catch(error => {
            console.log(error)
          });
      },
      dateRangeChange(val){
        const dates = val.split('a').map(item => {
          return item.trim()
        });
        dates.length === 2 ? this.rangeDate = dates : '';
      }
    },
    watch:{
      rangeDate(val){
        this.SET_ORDERS([]);
        this.SET_PAGINATION({})
        this.GET_ORDERS({
          page:1,
          dates: val
        }).then(() => {
          this.pageActual = this.pagination.page;
        })
      }
    }
  }
</script>

<style scoped>

</style>
